import { render } from "./CloseLimit.vue?vue&type=template&id=23de8369"
import script from "./CloseLimit.vue?vue&type=script&lang=js"
export * from "./CloseLimit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__